export default {
    'name': 'valuation',
    'label': 'valuation.title',
    'getComponent': () => import('./valuation.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/valuation',
};
